import { ZHContent } from '@/protocol/ZH/privacy';
const protocol = {
	banner: [{
		tips:'协议',
		title:'协议',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],	
	agreement:ZHContent 
}

export default protocol
